<template>
<el-container>
  <div v-if="common.isMobile() === false">
    <publicHeader ref="child" @hotelLanguage="hotelLanguage"></publicHeader>
  </div>
  <div v-else>
    <div style="height:60px; background-color:rgba(79, 76, 76, 1);">
      <router-link :to="{name:'Home', params: {'querys': common.linkEncode({'source': source, 'conver': conver}, 'obj')}}">
        <i class="el-icon-arrow-left" style="color: white;height: 20px; width: 20px; font-size: 20px; position: absolute;margin: 20px 0px 20px 20px;"></i>
      </router-link>
      <div style="font-weight: 650; font-style: normal; font-size: 16px; color: #FFFFFF; text-align: center; height: 60px; line-height: 60px;">{{$t('signIn')}}</div>
    </div>
  </div>
  <el-main :class="{'top-pc': common.isMobile() === false}">
      <div class="login-main">
        <div class="login-info">
          <div style="padding:6%;padding-bottom: 12%;">
            <form class="el-form demo-ruleForm login-form">
              <el-tabs v-model="activeName" @tab-click="loginChange" id="loginTabs">
                <el-tab-pane :label="$t('emailLogin')" name="emailLogin">
                  <div style="height: 56px">
                    <div class="login-remind" v-show="actionSuccess">
                      <div class="login-remindinfo">
                        <div class="login-img">
                          <img src="https://res.roompai.com/static/img/account/my-payment-yes.png" style="width:12px; height:12px;display: block;margin: 3px auto;">
                        </div>
                        <div class="login-remind-text">{{$t(actionSuccessNotice)}}</div>
                      </div>
                    </div>
                    <div class="login-remind" v-show="remindSuccess">
                      <div class="login-remindinfo">
                        <div class="login-img">
                          <img src="https://res.roompai.com/static/img/account/my-payment-yes.png" style="width:12px; height:12px;display: block;margin: 3px auto;">
                        </div>
                        <div class="login-remind-text">{{$t('linkToResetYoutPasswordSend')}} {{inputEmail}} {{$t('pleaseCheckYoutEmail')}}</div>
                      </div>
                    </div>
                    <div class="login-remind" v-show="registerSuccess">
                      <div class="login-remindinfo">
                        <div class="login-img">
                          <img src="https://res.roompai.com/static/img/account/my-payment-yes.png" style="width:12px; height:12px;display: block;margin: 3px auto;">
                        </div>
                        <div class="login-remind-text">{{$t('verifyEmailSendEmail')}} {{inputEmail}}</div>
                      </div>
                    </div>
                    <div class="login-remind-faild" :class="{'faild': verifyFail}" v-show="verifyFail">
                      <div class="login-remindinfo">
                        <div class="login-img-faild">
                          <img src="https://res.roompai.com/static/img/account/my-error.png" style="width:12px; height:12px;display: block;margin: 3px auto;">
                        </div>
                        <div class="login-remind-text-faild">{{$t('userEmailVerifyFail')}}</div>
                      </div>
                    </div>
                    <div class="login-remind-faild" :class="{'faild': notVerify}" v-show="notVerify">
                      <div class="login-remindinfo">
                        <div class="login-img-faild">
                          <img src="https://res.roompai.com/static/img/account/my-error.png" style="width:12px; height:12px;display: block;margin: 3px auto;">
                        </div>
                        <div class="login-remind-text-faild">{{$t('emailNotVerify')}}</div>
                      </div>
                    </div>
                    <div class="login-remind-faild no-transition" :class="{'faild': remindFaild}" v-show="remindFaild">
                      <div class="login-remindinfo">
                        <div class="login-img-faild">
                          <img src="https://res.roompai.com/static/img/account/my-error.png" style="width:12px; height:12px;display: block;margin: 3px auto;">
                        </div>
                        <div class="login-remind-text-faild">
                          <span v-html="getLanguageHtml(remindMessage,'remindMessage')"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="login-name">{{$t('electronEmail')}}</div>
                    <div class="el-form-item__content">
                      <div class="el-input">
                        <input type="text" autocomplete="off" class="el-input__inner" ref="emailinput" :placeholder="$t('electronEmail')">
                      </div>
                    </div>
                  </div>
                  <div :class="{'marginTop40':common.isWechat() === false, 'marginTop25':common.isWechat() === true}">
                    <div class="login-name">{{$t('password')}}</div>
                    <div class="el-form-item__content">
                      <el-input  :type="eyeOpen === true ? 'password' : 'text'" v-model="pwdInput" :placeholder="$t('password')" v-on:input="search" @focus="showPassImg = true" @blur="showPassImg === true ? showPassImg = true : showPassImg = false" tabindex="2"></el-input>
                      <img :src="eyeOpen === true ? eyeCloseImg : eyeOpenImg" class="eye" v-show="showPassImg" @click="eyeOpen === true ? eyeOpen = false : eyeOpen = true">
                    </div>
                  </div>
                  <div class="marginTop40">
                    <el-button :class="{'login_send':!login_send_show, 'login_send_active':login_send_show}" @click="submitForm()" data-index="login-button">{{$t('signIn')}}</el-button>
                  </div>
                </el-tab-pane>
                <el-tab-pane :label="$t('mobileLogin')" name="mobileLogin">
                  <div style="height: 56px">
                    <div class="login-remind" v-show="actionSuccessMobile">
                      <div class="login-remindinfo">
                        <div class="login-img">
                          <img src="https://res.roompai.com/static/img/account/my-payment-yes.png" style="width:12px; height:12px;display: block;margin: 3px auto;">
                        </div>
                        <div class="login-remind-text">{{$t(actionSuccessMobileNotice)}}</div>
                      </div>
                    </div>
                    <div class="login-remind-faild" v-show="remindFaildMobile">
                      <div class="login-remindinfo">
                        <div class="login-img-faild">
                          <img src="https://res.roompai.com/static/img/account/my-error.png" style="width:12px; height:12px;display: block;margin: 3px auto;">
                        </div>
                        <div class="login-remind-text-faild">
                          <span v-html="getLanguageHtml(remindMessageMobile,'remindMessage')"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="login-name">{{$t('mobileTitle')}}</div>
                    <div class="el-form-item__content">
                      <div class="el-input input-bor">
                        <el-select style="width:25%;" v-model="selectTel" :placeholder="$t('pleaseSelect')">
                          <el-option v-for="item in telOptions" :label="item.telnum" :key="item.id" :value="item.id">{{item.value}}</el-option>
                        </el-select>
                        <input style="width:73%;" type="text" autocomplete="off" class="el-input__inner" ref="mobileinput" :placeholder="$t('mobile')">
                      </div>
                    </div>
                    <div class="el-form-item__content">
                      <div class="el-input">
                        <input type="text" autocomplete="off" class="el-input__inner" style="width: 65%;margin-right: 3%" ref="codeinput" :placeholder="$t('inputMobileCode')">
                        <el-button class="send_mobile_code" style="width: 30%;padding: 0" @click="getMobileCode()">
                          <span v-show="this.expireTime === 0">{{$t('getMobileCode')}}</span>
                          <span v-show="this.expireTime > 0">{{expireTime}}S</span>
                        </el-button>
                      </div>
                    </div>
                  </div>
                  <div class="marginTop40">
                    <el-button :class="{'login_send':!login_send_show, 'login_send_active':login_send_show}" @click="submitMobileForm()" data-index="login-button">{{$t('signIn')}}</el-button>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </form>
            <div class="login-other">
              <div style="display:inline-block; float:left;">
                <router-link :to="{name:'register', params: {'querys': common.linkEncode({'source': source, 'conver': conver}, 'obj')}}">{{$t('createAccount')}}</router-link>
              </div>
              <div style="display:inline-block; float:right;">
                <router-link :to="{name:'forgetPass', params: {'querys': common.linkEncode({'source': source, 'conver': conver}, 'obj')}}">{{$t('forgotPassword')}}？</router-link>
              </div>
            </div>
            <authorizedLoginModule pageTitle="authorizedLoginTitle"></authorizedLoginModule>
          </div>
        </div>
      </div>
  </el-main>
  <publicFooter></publicFooter>
</el-container>
</template>
<script>
import {signIn, emailVerify, authorizedLogin} from '@/request/login.js'
import publicFooter from '@/components/public/publicFooter'
import publicHeader from '@/components/public/publicHeader'
import authorizedLoginModule from '@/components/login/module/authorizedLogin'

export default {
  name: 'login',
  components: {
    publicFooter,
    publicHeader,
    authorizedLoginModule
  },
  data () {
    return {
      title: 'signIn',
      emailTitle: 'emailSignIn',
      mobileTitle: 'mobileSignIn',
      activeName: 'emailLogin',
      actionSuccessMobile: false,
      actionSuccessMobileNotice: '',
      remindFaildMobile: false,
      remindMessageMobile: '',
      telOptions: [],
      telOptionsEn: {
        www: [{id: 216, value: 'United States +1', telnum: 'US +1'}, {id: 36, value: 'Canada +1', telnum: 'CA +1'}, {id: 42, value: 'China +86', telnum: 'CN +86'}],
        us: [{id: 216, value: 'United States +1', telnum: 'US +1'}, {id: 36, value: 'Canada +1', telnum: 'CA +1'}, {id: 215, value: 'United Kingdom +44', telnum: 'GB +44'}]
      },
      telOptionsCn: {
        www: [{id: 216, value: '美国 +1', telnum: 'US +1'}, {id: 36, value: '加拿大 +1', telnum: 'CA +1'}, {id: 42, value: '中国 +86', telnum: 'CN +86'}],
        us: [{id: 216, value: '美国 +1', telnum: 'US +1'}, {id: 36, value: '加拿大 +1', telnum: 'CA +1'}, {id: 215, value: 'United Kingdom +44', telnum: 'GB +44'}]
      },
      selectTel: 216,
      expireTime: 0,
      codeTimeExpire: false,
      remindFaild: false,
      verifyFail: false,
      notVerify: false,
      remindSuccess: false,
      registerSuccess: false,
      remindMessage: 'emailOrPasswordIncorrect',
      inputEmail: '',
      login_send_show: false,
      source: 'roompai',
      actionSuccess: false,
      actionSuccessNotice: '',
      site: this.getSite(),
      language: this.common.languageSet(this),
      pwdInput: '',
      eyeOpenImg: '/static/img/login/open-eye.png',
      eyeCloseImg: '/static/img/login/close-eye.png',
      showPassImg: false,
      eyeOpen: true,
      conver: ''
    }
  },
  beforeCreate () {
  },
  created: function () {
  },
  mounted () {
    let site = this.site === 'us' ? 'us' : 'www'
    this.telOptions = this.language === 'en' ? this.telOptionsEn[site] : this.telOptionsCn[site]
    // 判断是否登陆
    var token = localStorage.getItem('token')
    if (token !== null) {
      localStorage.removeItem('token')
      // this.$router.push({name: 'Home'})
    }
    var conver = this.common.linkQuerys.conver
    if (conver === 1 || conver === '1') {
      this.conver = conver
    }
    // 是否从忘记密码跳转过来 是否弹框
    var emailSendTips = sessionStorage.getItem('emailSendTips')
    if (emailSendTips !== null) {
      this.remindSuccess = true
      this.inputEmail = emailSendTips
    }
    // 是否从注册跳转过来 是否弹框
    var verifyEmailSendEmail = sessionStorage.getItem('verifyEmailSendEmail')
    if (verifyEmailSendEmail !== null) {
      this.registerSuccess = true
      this.inputEmail = verifyEmailSendEmail
    }
    // this.verifyResult()
    this.emailVerify()
    // 下拉框关闭
    document.addEventListener('click', this.bodyCloseMenus)

    // 存储来源
    var source = this.common.linkQuerys.source
    // 过期时间 5个小时
    if (source !== '' && source !== undefined && source !== null) {
      this.source = source
    }
    // 判断如果是us站点的google渠道，则拉取更多的国家代码 ['124', '125'].includes(res.flag).
    if (this.site === 'us' && ['google', 'google2', 'google_b2b', 'google2_b2b'].includes(this.source)) {
      this.getMoreCountryCode()
    }
  },
  beforeDestroy () {
    document.removeEventListener('click', this.bodyCloseMenus)
  },
  watch: {
    language: function (newCur, oldCur) {
      let site = this.site === 'www' ? 'www' : 'us'
      this.telOptions = newCur === 'en' ? this.telOptionsEn[site] : this.telOptionsCn[site]
    }
  },
  methods: {
    hotelLanguage (language) {
      this.language = language
    },
    loginChange (tab, event) {
      console.log(tab, event)
    },
    getMoreCountryCode () {
      var requestTime = parseInt(new Date().getTime())
      var time = parseInt(requestTime / 1000)
      var sessionid = this.common.sessionidGet(this)
      let dataJson = {'time': time, 'sessionid': sessionid, 'operation': 'getMoreCountryCode', 'language': this.language}
      var data = this.common.encryptionData(dataJson, this)
      authorizedLogin(data).then(res => {
        console.log('getMoreCountryCode')
        console.log(res)
        var responseTime = parseInt(new Date().getTime())
        this.loadPageView(data, res, requestTime, responseTime)
        if (res.flag === '200') {
          this.telOptions = res.data.countryCode
          console.log('xxxxxxxxxxxxxxxxx')
          console.log(this.telOptions)
        }
      })
    },
    getMobileCode () {
      var mobile = this.$refs['mobileinput'].value
      if (mobile === '') {
        this.remindMessageMobile = 'pleaseValidPhone'
        this.remindFaildMobile = true
        this.$refs['mobileinput'].focus()
        return false
      }
      if (this.expireTime > 0) {
        return false
      }
      var that = this
      this.remindFaildMobile = false
      this.actionSuccessMobile = false
      var requestTime = parseInt(new Date().getTime())
      var time = parseInt(requestTime / 1000)
      var sessionid = this.common.sessionidGet(this)
      let dataJson = {'mobile': mobile, 'areaCode': this.selectTel, 'time': time, 'sessionid': sessionid, 'operation': 'sendCode'}
      var data = this.common.encryptionData(dataJson, this)
      authorizedLogin(data).then(res => {
        console.log(res)
        var responseTime = parseInt(new Date().getTime())
        this.loadPageView(data, res, requestTime, responseTime)
        if (res.flag === '200') {
          this.actionSuccessMobileNotice = 'sendCodeSuccess'
          this.actionSuccessMobile = true
          that.expireTime = 59
          that.codeTimeExpire = setInterval(function () {
            if (that.expireTime === 0) {
              clearInterval(that.codeTimeExpire)
            } else {
              that.expireTime = that.expireTime - 1
            }
          }, 1000)
        } else if (res.flag === '102') {
          this.$message({
            type: 'error',
            message: this.$t(res.msg)
          })
        } else {
          this.remindMessageMobile = res.code
          this.remindFaildMobile = true
        }
      })
    },
    submitMobileForm () {
      var mobile = this.$refs['mobileinput'].value
      var code = this.$refs['codeinput'].value
      if (mobile === '') {
        this.remindMessageMobile = 'pleaseValidPhone'
        this.remindFaildMobile = true
        this.$refs['mobileinput'].focus()
        return false
      }
      if (code === '') {
        this.remindMessageMobile = 'pleaseValidMobileCode'
        this.remindFaildMobile = true
        this.$refs['codeinput'].focus()
        return false
      }
      this.remindFaildMobile = false
      this.actionSuccessMobile = false
      var LoginWebsiteAddress = sessionStorage.getItem('LoginWebsiteAddress')
      var requestTime = parseInt(new Date().getTime())
      var time = parseInt(requestTime / 1000)
      var sessionid = this.common.sessionidGet(this)
      var searchHotelLocation = sessionStorage.getItem('search_hotel_location')
      let dataJson = {'mobile': mobile, 'areaCode': this.selectTel, 'code': code, 'source': this.source, 'language': this.language, 'site': this.site, 'time': time, 'sessionid': sessionid, 'operation': 'Mobile', 'searchHotelLocation': searchHotelLocation !== null ? searchHotelLocation : ''}
      var data = this.common.encryptionData(dataJson, this)
      authorizedLogin(data).then(res => {
        var responseTime = parseInt(new Date().getTime())
        this.loadPageView(data, res, requestTime, responseTime)
        if (res.flag === '200' || res.flag === '201') {
          localStorage.setItem('token', res.data.token)
          this.actionSuccessMobileNotice = 'loginSuccess'
          this.actionSuccessMobile = true
          // 登录成功，延迟1秒后进行跳转.
          setTimeout(() => {
            if (LoginWebsiteAddress !== null && LoginWebsiteAddress.indexOf('login/login') === -1) {
              window.document.location.href = LoginWebsiteAddress
            } else {
              // if (this.source === 'roompai') {
              //   this.$router.push({name: 'Home'})
              // } else {
              //   this.$router.push({name: 'Home', query: {'source': this.source}})
              // }
              var newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
              if (this.conver === 1 || this.conver === '1') {
                newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
              }
              this.$router.push({name: 'Home', params: {'querys': newQuerys}})
            }
          }, 500)
        } else if (res.flag === '102' || res.flag === '103') {
          this.$message({
            type: 'error',
            message: this.$t(res.msg)
          })
        } else {
          this.remindMessageMobile = res.code
          this.remindFaildMobile = true
        }
      })
    },
    getSite () {
      let site = ''
      if (location.host === 'www.roompai.com') {
        site = 'www'
      } else if (location.host === 'us.roompai.com' || location.host === 'test.us.roompai.com') {
        site = 'us'
      }
      return site
    },
    submitForm () {
      sessionStorage.removeItem('emailSendTips')
      this.login_send_show = true
      var LoginWebsiteAddress = sessionStorage.getItem('LoginWebsiteAddress')
      var email = this.$refs['emailinput'].value
      if (email === '' || this.pwdInput.length < 6) {
        this.notVerify = false
        this.remindSuccess = false
        this.registerSuccess = false
        this.remindMessage = 'emailOrPasswordIncorrect'
        this.remindFaild = true
        return false
      } else {
        // ^([a-zA-Z]|[0-9])(\w|-)+@[a-zA-Z0-9]+.([a-zA-Z]{2,4})$
        var pattern = /^([a-zA-Z]|[0-9])(\.|\w|-)+@([a-zA-Z0-9])(\.|\w|-)+\.([a-zA-Z]{2,4})$/
        console.log(pattern.test(email))
        console.log(!pattern.test(email))
        if (!pattern.test(email)) {
          this.notVerify = false
          this.remindSuccess = false
          this.registerSuccess = false
          this.remindMessage = 'emailOrPasswordIncorrect'
          this.remindFaild = true
          return false
        }
      }
      this.remindFaild = false

      var requestTime = parseInt(new Date().getTime())
      var time = parseInt(requestTime / 1000)
      var sessionid = this.common.sessionidGet(this)
      var dataJson = {'email': email, 'password': this.pwdInput, 'time': time, 'sessionid': sessionid}
      var data = this.common.encryptionData(dataJson, this)

      signIn(data).then(res => {
        delete data.password
        var responseTime = parseInt(new Date().getTime())
        this.loadPageView(data, res, requestTime, responseTime)

        if (res.flag === '200' || res.flag === '201') {
          localStorage.setItem('token', res.data.token)
          // 检查是否要跳转到绑定手机号.
          if (res.data.riskLevelMedium === '1') {
            sessionStorage.setItem('BindMobileWebsiteAddress', LoginWebsiteAddress)
            this.$message({
              type: 'error',
              message: this.$t(res.msg)
            })
            setTimeout(() => {
              // this.$router.push({name: 'myAccount', query: {'source': this.source, 'bindMobile': '1', 'type': 'user'}})
              var newQuerys = this.common.linkEncode({'source': this.source, 'bindMobile': '1', 'type': 'user'}, 'obj')
              if (this.conver === 1 || this.conver === '1') {
                newQuerys = this.common.linkEncode({'source': this.source, 'bindMobile': '1', 'type': 'user', 'conver': this.conver}, 'obj')
              }
              this.$router.push({name: 'myAccount', params: {'querys': newQuerys}})
            }, 1000)
            return ''
          }
          this.actionSuccessNotice = 'loginSuccess'
          this.actionSuccess = true
          // 登录成功，延迟1秒后进行跳转.
          setTimeout(() => {
            if (LoginWebsiteAddress !== null && LoginWebsiteAddress.indexOf('login/login') === -1) {
              window.document.location.href = LoginWebsiteAddress
            } else {
              // if (this.source === 'roompai') {
              //   this.$router.push({name: 'Home'})
              // } else {
              //   this.$router.push({name: 'Home', query: { 'source': this.source }})
              // }
              var newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
              if (this.conver === 1 || this.conver === '1') {
                newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
              }
              this.$router.push({name: 'Home', params: {'querys': newQuerys}})
            }
          }, 1000)
        } else if (['124', '125'].includes(res.flag)) {
          this.remindSuccess = false
          this.registerSuccess = false
          this.remindFaild = false
          this.notVerify = true
        } else if (res.flag === '502') {
          this.remindSuccess = false
          this.notVerify = false
          this.registerSuccess = false
          this.remindFaild = true
          this.remindMessage = res.msg
        } else if (res.flag === '126') {
          // 账号不存在
          this.remindSuccess = false
          this.notVerify = false
          this.registerSuccess = false
          this.remindFaild = true
          this.remindMessage = 'noAccountMsg'
        } else if (res.flag === '102') {
          this.$message({
            type: 'error',
            message: this.$t(res.msg)
          })
        } else {
          this.remindSuccess = false
          this.notVerify = false
          this.registerSuccess = false
          this.remindFaild = true
          this.remindMessage = 'emailOrPasswordIncorrect'
        }
      })
    },
    emailVerify: function () {
      var LoginWebsiteAddress = sessionStorage.getItem('LoginWebsiteAddress')
      var email = this.common.linkQuerys.email
      var searchtime = this.common.linkQuerys.time
      var searchsign = this.common.linkQuerys.sign
      if (searchsign === undefined) {
        return ''
      }

      var sessionid = this.common.sessionidGet(this)
      var time = parseInt(new Date().getTime() / 1000)
      var dataJson = {
        'email': email,
        'searchsign': searchsign,
        'searchtime': searchtime,
        'time': time,
        'sessionid': sessionid,
        'operation': 'emailVerify'
      }
      var data = this.common.encryptionData(dataJson, this)
      emailVerify(data).then(res => {
        if (res.flag === '200') {
          localStorage.setItem('token', res.data.token)
          if (LoginWebsiteAddress !== null && LoginWebsiteAddress.indexOf('login/login') === -1) {
            window.document.location.href = LoginWebsiteAddress
          } else {
            // if (this.source === 'roompai') {
            //   this.$router.push({name: 'Home'})
            // } else {
            //   this.$router.push({name: 'Home', query: {'source': this.source}})
            // }
            var newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
            if (this.conver === 1 || this.conver === '1') {
              newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
            }
            this.$router.push({name: 'Home', params: {'querys': newQuerys}})
          }
        } else if (res.flag === '102') {
          this.$message({
            type: 'error',
            message: this.$t(res.msg)
          })
        } else {
          this.verifyFail = true
          this.remindSuccess = false
          this.registerSuccess = false
        }
        // console.log(res)
      })
    },
    getLanguageHtml: function (data, type) {
      if (data === undefined) {
        return ''
      }
      // var getLanguage = this.common.languageSet(this)
      if (['remindMessage'].includes(type)) {
        var remark = this.$t(data)
        if (data === 'verifyEmailSendEmail') {
          remark = this.$t(data) + ' ' + this.send_email
        }
        return remark
      }
    },
    bodyCloseMenus: function (node) {
      if (node.target.getAttribute('data-index') !== 'login-button') {
        if (this.login_send_show === true) {
          this.login_send_show = false
        }
      }
    }
  }
}
</script>

<style scoped>
/deep/ .top-pc{margin-top: 60px;}
.login-main{background-color: rgb(255, 241, 180);width:100%;padding-bottom:10px; margin:0 auto;height: 100vh;padding-top: 4%;}
.login-info{margin: 0 auto;background-color: rgba(255, 255, 255, 1);border: none;-moz-box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.09803921568627451); -webkit-box-shadow: 0px 2px 12px rgb(0 0 0 / 10%);box-shadow: 0px 2px 12px rgb(0 0 0 / 10%);}

.login-info-wechat{background-color:white;height:500px;}
.login-info-left{display: inline-block;width: 440px}
.login-info-right{margin-top:64px;float: right;margin-right:20px;}

.wechat-authorization-success {margin-top: 42px;float:right;margin-right: 30px; width: 310px;text-align: center}
.wechat-authorization-success .title {
  font-weight: 650;
  font-size: 24px;
  height: 60px;
  background-color: rgba(255, 255, 255, 0);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.wechat-authorization-success .success-icon {height: 150px;width: 150px;}
.wechat-authorization-success .desc {text-align: center;margin-top: 20px;margin-bottom:20px;color:#606266;font-size: 14px;}
.wechat-authorization-success .dots {text-align: center}
.wechat-authorization-success .dots img {height: 30px}
.wechat-authorization-success .directLogin {width: 70%}

.bindEmail {margin: 0  !important;color: #4F4C4C;background-color: #ffffff;width: 100%;height: 44px;font-size: 16px;font-weight: 400;font-style:normal;-webkit-box-sizing: border-box;box-sizing: border-box;border: 1px solid rgba(79, 76, 76, 1);border-radius: 4px;}

.bindEmail:hover{
  cursor: pointer;
  -webkit-box-shadow: 5px 5px 5px rgb(0 0 0 / 35%);
  box-shadow: 5px 5px 5px rgb(0 0 0 / 35%);
}

.logintext{font-weight: 650;font-size: 24px; height: 50px;background-color: rgba(255, 255, 255, 0);box-sizing: border-box;border-bottom: 1px solid rgba(221, 223, 226, 1);}
.login-form{margin:15px 0px; color:#606266;font-size: 14px;}
.login-form input{ margin-top:10px;}
.send_mobile_code,.login_send{width: 100%;height: 40px; font-size:14px; background-color: rgba(79, 76, 76, 1);box-sizing: border-box;border: 1px solid rgba(79, 76, 76, 1);border-radius: 4px;-moz-box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.34901960784313724);color: #FFFFFF;}
.send_mobile_code:hover, .send_mobile_code{background-color: rgba(79, 76, 76, 1) !important; color:#ffffff !important;}
.login_send:hover{background-color: rgb(252, 210, 5, 1);border-color: rgb(252, 210, 5, 1); color:rgb(79,76,76)}
.login_send_active{width: 100%;height: 44px; font-size:16px; background-color: rgb(252, 210, 5, 1)!important;box-sizing: border-box;border: 1px solid rgba(79, 76, 76, 1)!important;border-radius: 4px;-moz-box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.34901960784313724)!important;-webkit-box-shadow: 5px 5px 5px rgb(0 0 0 / 35%)!important;border-color: rgb(252, 210, 5, 1)!important;box-shadow: 5px 5px 5px rgb(0 0 0 / 35%)!important;color: rgb(79,76,76)!important;}
.marginTop40{margin-top: 40px;}
.marginTop35{margin-top: 35px;}
.marginTop25{margin-top: 25px;}
.marginTop15{margin-top: 15px;}
.marginTop10{margin-top: 10px;}
.marginLeft0{margin-left: 0px !important;}
.no-transition {transition: none !important;}
.login-other {height: 35px}
.login-other a{ font-size:14px; color:#5392F9;text-decoration-line: none;}
.login-other-button {width: 100%;height: 44px;}
.wechat-button {background:url(/static/img/login/wechat.png) no-repeat 2px; background-size: 25px 25px; color: #5392F9;padding-left: 30px;}
.el-input.is-active .el-input__inner, .el-input__inner:focus{border-color:rgba(252,210,5,1);box-shadow:0px 0px 8px rgba(252,210,5);}
/deep/ .el-button:not(.send_mobile_code):focus, .el-button:not(.send_mobile_code):hover{color:rgb(79,76,76)!important;border-color:rgb(252, 210, 5, 1)!important;background-color:rgb(252, 210, 5, 1)!important;}
.login /deep/ .el-input__inner{padding: 0 45px 0 15px;}
.eye{height: 15px; width: 15px; position: absolute;top: 12.5px; right: 15px; cursor: pointer;}
/*提示*/
.login-remind-notice{border-width: 0px;min-height: 56px;background: inherit;border: none;border-radius: 4px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;}
.login-remind-notice-text{line-height: 20px; font-size: 14px;font-weight: 400;color:#5392F9;display:inline-block;width:90%;margin-top:10px}
.login-remind-notice img {width: 18px;height: 18px;margin-right: 5px;}
/* 登录提醒 */
.login-remind{ border-width: 0px;height: 56px;background: inherit;background-color: rgba(240, 249, 235);border: none;border-radius: 4px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;}
.login-remindinfo{padding-right: 18px;display: flex;justify-content: center;align-items: center; line-height:56px;}
.login-img{ margin: 18px;width: 18px;height: 18px;background-color: rgba(103, 194, 58, 1);border: none;border-radius: 15px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;text-align: center;line-height: normal;display:inline-block; margin-right:10px;}
.login-remind-text{color: #67C23A;line-height: 20px; font-size:14px;display:inline-block;width:90%;}
/* 失败 */
.login-remind-faild{overflow: hidden;background: inherit;background-color: rgba(254, 240, 240, 1);border-width: 0px;height: 56px;border: none;border-radius: 4px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;}
.login-img-faild{margin: 18px;width: 18px;height: 18px;background-color: rgba(245, 108, 108, 1);border: none;border-radius: 15px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;text-align: center;line-height: normal;display:inline-block; margin-right:10px;}
.login-remind-text-faild{color: #F56C6C;line-height: 20px; font-size:14px;display:inline-block;width:90%;}
.codeError,.codeError:focus,.codeError:hover{background: inherit;background-color: rgba(255, 255, 255, 1);box-sizing: border-box;border: 2px solid rgba(225, 45, 45, 1);border-radius: 4px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;}
.mybox-leave-active,
.mybox-enter-active {
  transition: all 1s ease;
}

.mybox-leave-active,
.mybox-enter {
  height: 0px !important;
}

.mybox-leave,
.mybox-enter-active {
  height: 56px;
}
@media screen and (min-width: 1001px) {
  .login-info{width: 500px;}
  .login-info-wechat{width: 890px;}
}
@media screen and (max-width: 1000px) {
  .login-info{width: 97%;}
}
</style>



// WEBPACK FOOTER //
// src/components/login/login.vue